<div class="tp-page">
  <tp-page-header
    title="Carga de franquicias"
    subtitle="Importá clientes y prestadores de una franquicia desde un archivo .csv"
  ></tp-page-header>

  <div class="ffu-grid">
    <section class="tp-card ffu-card">
      <h2 class="tp-card__title">Carga de clientes</h2>
      <div class="tp-form__field">
        <label class="tp-form__label" for="ffu-client-franchise">Franquicia</label>
        <select
          id="ffu-client-franchise"
          class="custom-select"
          [(ngModel)]="franchiseId"
          required
          tabindex="-1"
          (change)="franchiseSelected()"
        >
          @for (franchise of franchises; track franchise) {
            <option [ngValue]="franchise.id">
              {{ franchise.name }}
            </option>
          }
        </select>
        @if (showClientFranchisError) {
          <span class="ffu-error">
            Debe seleccionar una franquicia
          </span>
        }
      </div>
      <div class="tp-form__field">
        <span class="tp-form__label">Archivo de clientes</span>
        <form [formGroup]="csvClientForm">
          <div
            [ngClass]="dragAreaClass"
            (drop)="onClientFileDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
          >
            <div
              class="files-drag-container"
              (click)="clientFile.click()"
            >
              <mat-icon class="ffu-drop-icon" aria-hidden="true">upload_file</mat-icon>
              <h3>Arrastrá el archivo .csv</h3>
              @if (!csvClientForm.get('csvClientFile')?.value) {
                <span class="ffu-hint">Arrastrá archivos hasta acá o hacé clic para subir un nuevo archivo</span>
              }
              @if (csvClientForm.get('csvClientFile')?.value) {
                <div class="ffu-file">
                  <span class="file-name">{{
                    csvClientForm.get("csvClientFile")?.value.name
                  }}</span>
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="Quitar archivo"
                    title="Quitar archivo"
                    (click)="removeClientFile()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
              <button
                mat-stroked-button
                type="button"
                [disabled]="csvClientForm.get('csvClientFile')?.value"
              >
                Subir un archivo
              </button>
              <input
                type="file"
                #clientFile
                style="display: none"
                accept=".csv"
                (change)="onClientFileChange($event)"
                class="file-input"
              />
            </div>
          </div>

          @if (clientErrorMessage) {
            <div class="ffu-error">
              {{ clientErrorMessage }}
            </div>
          }
          @if (clientSuccessMessage) {
            <div class="ffu-success">
              {{ clientSuccessMessage }}
            </div>
          }
        </form>
      </div>
      <div class="ffu-actions">
        <button mat-flat-button (click)="submitClients()" [disabled]="csvClientForm.invalid">
          Cargar archivo
        </button>
      </div>
    </section>

    <section class="tp-card ffu-card">
      <h2 class="tp-card__title">Carga de prestadores</h2>
      <div class="tp-form__field">
        <label class="tp-form__label" for="ffu-supplier-franchise">Franquicia</label>
        <select
          id="ffu-supplier-franchise"
          class="custom-select"
          [(ngModel)]="franchiseSupplierId"
          required
          tabindex="-1"
          (change)="franchiseSupplierSelected()"
        >
          @for (franchise of franchises; track franchise) {
            <option [ngValue]="franchise.id">
              {{ franchise.name }}
            </option>
          }
        </select>
        @if (showSupplierFranchisError) {
          <span class="ffu-error">
            Debe seleccionar una franquicia
          </span>
        }
      </div>
      <div class="tp-form__field">
        <span class="tp-form__label">Archivo de prestadores</span>
        <form [formGroup]="csvSupplierForm">
          <div
            [ngClass]="dragAreaClass"
            (drop)="onSupplierFileDrop($event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
          >
            <div
              class="files-drag-container"
              (click)="supplierFile.click()"
            >
              <mat-icon class="ffu-drop-icon" aria-hidden="true">upload_file</mat-icon>
              <h3>Arrastrá el archivo .csv</h3>
              @if (!csvSupplierForm.get('csvSupplierFile')?.value) {
                <span class="ffu-hint">Arrastrá archivos hasta acá o hacé clic para subir un nuevo archivo</span>
              }
              @if (csvSupplierForm.get('csvSupplierFile')?.value) {
                <div class="ffu-file">
                  <span class="file-name">{{
                    csvSupplierForm.get("csvSupplierFile")?.value.name
                  }}</span>
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="Quitar archivo"
                    title="Quitar archivo"
                    (click)="removeSupplierFile()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              }
              <button
                mat-stroked-button
                type="button"
                [disabled]="csvSupplierForm.get('csvSupplierFile')?.value"
              >
                Subir un archivo
              </button>
              <input
                type="file"
                #supplierFile
                style="display: none"
                accept=".csv"
                (change)="onSupplierFileChange($event)"
                class="file-input"
              />
            </div>
          </div>

          @if (supplierErrorMessage) {
            <div class="ffu-error">
              {{ supplierErrorMessage }}
            </div>
          }
          @if (supplierSuccessMessage) {
            <div class="ffu-success">
              {{ supplierSuccessMessage }}
            </div>
          }
        </form>
      </div>
      <div class="ffu-actions">
        <button mat-flat-button (click)="submitSuppliers()" [disabled]="csvSupplierForm.invalid">
          Cargar archivo
        </button>
      </div>
    </section>
  </div>
</div>
